import React from "react"

import { getCxFromStyles } from "../../helpers"
import * as styles from "./RateDescription.module.scss"
import starIcon from "../../assets/star.svg"

const AgencyRateDescription: React.FC = () => {
  const cx = getCxFromStyles(styles)

  return (
    <div className={cx("root")}>
      <div className={cx("list_container")}>
        <span>
          <span className={cx("starbox")}>
            <img src={starIcon} alt="" aria-hidden="true" />
            <img src={starIcon} alt="" aria-hidden="true" />
            <img src={starIcon} alt="" aria-hidden="true" />
          </span>
        </span>
        <span>
          <p className={cx("rate_title")}>
            <strong>Rate description verification tool</strong>
          </p>
          <p className={cx("content")}>
            <strong>Rate Cleaner</strong> provides a comprehensive solution for
            travel agencies to ensure accurate travel agencies to ensure
            accurate rate descriptions in GDSs, facilitating direct
            communication with hotels to resolve rate issues.
          </p>
        </span>
      </div>
    </div>
  )
}

export default AgencyRateDescription
